import { render } from "./ListeClientAffecterPage.vue?vue&type=template&id=dd00b44a&ts=true"
import script from "./ListeClientAffecterPage.vue?vue&type=script&lang=ts"
export * from "./ListeClientAffecterPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__